import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactTable from 'react-table';

import 'react-table/react-table.css';

import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import OptionsDropdown from 'components/shared/OptionsDropdown';

import { numberOfRows } from 'helpers/ReactTableSize';
import { isFilterInStrings } from 'helpers/StringHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { toFriendlyDateString } from 'helpers/Formatter';
import { localize } from 'react-localize-redux';

class PromotionsTable extends Component {
  constructor(props) {
    super(props);
    const tableSize = numberOfRows(props.promotions);
    this.state = {
      tableSize,
      typeFilter: '',
    };
  }

  getTypeFilterType = e => {
    this.setState({ typeFilter: e.target.value });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const tableSize = numberOfRows(nextProps.promotions);
    this.setState(
      {
        tableSize,
        data: nextProps.promotions,
      },
      function() {
        this.forceUpdate();
      }
    );
  }

  render() {
    const data = this.props.promotions || [];
    const { translate, languageCode } = this.props;
    let filteredData = [];
    if (data && data.length > 0) {
      filteredData = data.filter(item =>
        isFilterInStrings([item.name, item.is_external, item.vendor], this.state.typeFilter)
      );
    }

    const columns = [
      {
        header: translate('landlordPortal.promotions.name'),
        headerClassName: 'headerColumn',
        accessor: 'name',
      },
      {
        header: translate('landlordPortal.promotions.external'),
        headerClassName: 'headerColumn',
        accessor: 'is_external',
        render: row =>
          row.value === true
            ? translate('landlordPortal.promotions.yes')
            : translate('landlordPortal.promotions.no'),
      },
      {
        header: translate('landlordPortal.promotions.expirationDate'),
        headerClassName: 'headerColumn',
        accessor: 'expiration_date',
        render: row =>
          row.value ? toFriendlyDateString(row.value, { language: languageCode }) : 'N/A',
      },
      {
        header: translate('landlordPortal.promotions.action'),
        headerClassName: 'headerColumn',
        accessor: 'id',
        render: row =>
          row.value ? (
            <OptionsDropdown allowedOpen={!this.props.optionsDropdown}>
              <MenuItem
                primaryText={translate('landlordPortal.promotions.details')}
                style={{ fontSize: '14px' }}
                onClick={() => this.props.togglePromotionDetailsDialog(row.row)}
              />
            </OptionsDropdown>
          ) : (
            ''
          ),
      },
    ];

    return (
      <div>
        <div className="stage-header clearfix" style={{ marginBottom: '25px' }}>
          <FlatButton
            label={this.props.translate('landlordPortal.promotions.addPromotion')}
            type="submit"
            primary={true}
            backgroundColor={AccentColor()}
            hoverColor="grey"
            onClick={this.props.togglePromotionDialog}
            style={{
              color: 'white',
              float: 'right',
              height: '30px',
              fontSize: '13px',
              lineHeight: '30px',
              marginTop: '3px',
            }}
          />
          <span className="page-title">
            {this.props.translate('landlordPortal.promotions.promotions')}
          </span>
        </div>
        <div className="dashboard-container" style={{ marginBottom: '70px' }}>
          <div className="row" style={{ marginTop: '-20px' }}>
            <TextField
              hintText={this.props.translate('landlordPortal.promotions.filterBy')}
              style={{ fontSize: '13px' }}
              value={this.state.typeFilter}
              onChange={this.getTypeFilterType}
            />
          </div>
          <ReactTable
            collapseOnSortingChange={false}
            collapseOnPageChange={false}
            collapseOnDataChange={false}
            data={filteredData}
            columns={columns}
            pageSize={this.state.tableSize}
            noDataText={this.props.translate('landlordPortal.promotions.noPromotions')}
            showPagination={false}
            showPageSizeOptions={false}
          />
        </div>
      </div>
    );
  }
}

export default localize()(
  connect(state => ({
    languageCode: state.locale.currentLanguage,
  }))(PromotionsTable)
);
